// V182 — Shared helpers for the admin Payment Links UI.
export const PUBLIC_BASE = (typeof window !== "undefined") ? window.location.origin : "";
export const fmtInr = (n) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(n) || 0);
export const fmtDate = (iso) => iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—";
export const linkUrl = (it) => `${PUBLIC_BASE}/pay/${it.id}`;

/** Client-facing WhatsApp text — never includes the private client_search_name. */
export function waMessage(it) {
    const sessions = it.session_count ? ` · ${it.session_count} session${it.session_count === 1 ? "" : "s"}` : "";
    const desc = it.description ? ` — ${it.description}` : "";
    return `Hi, here is your Anand Tutorials payment link for ${fmtInr(it.amount)}${sessions}${desc}: ${linkUrl(it)}`;
}

/** Pre-addressed chat when a contact exists, otherwise WhatsApp's recipient picker. */
export const waHref = (it, pickRecipient = false) =>
    `https://wa.me/${!pickRecipient && it.contact_number ? it.contact_number : ""}?text=${encodeURIComponent(waMessage(it))}`;

export const isEditable = (it) => (it.status || "pending") === "pending";

/** Client details reused when creating a new request for the same family. */
export const clientPrefill = (src, parentLinkId = "") => ({
    client_search_name: src.client_search_name || "",
    student_name: src.student_name || "",
    parent_name: src.parent_name || "",
    enquiry_id: src.enquiry_id || "",
    contact_number: src.contact_number ? `+${src.contact_number}` : "",
    parent_link_id: parentLinkId,
});

export async function copyUrl(url, toast) {
    try { await navigator.clipboard.writeText(url); toast.success("Link copied"); }
    catch { toast.error("Long-press the link and copy manually"); }
}
